import { useAppSelector } from '@app/store/hooks';
import { Theme, ThemedView } from '@app/theme';
import { checkColor } from '@app/utils/utils';
import { useTheme } from '@shopify/restyle';
import LottieView from 'lottie-react-native';
import { useEffect, useState } from 'react';
import { ActivityIndicator } from 'react-native';

const Loading  =()=>{
      const {isfromTDL} = useAppSelector(state => state.platformParams);
      const {colors} = useTheme<Theme>();
    
      return(
        <ThemedView flex={1} alignItems='center' justifyContent='center' backgroundColor="bg-surface-primary" >
        {
        isfromTDL ? 
        <LottieView
            source={require('../../../assets/lottie/tdl_loader.json')}
            style={{width: 273, height: 378}}
            autoPlay={true}
            loop={true}
        />
        :
        <ActivityIndicator size={12} color={colors['icon-action-primary']} />
        }
      </ThemedView>
      )
}

export default Loading;